import { render, staticRenderFns } from "./DeleteMedia.vue?vue&type=template&id=11bf2750"
import script from "./DeleteMedia.vue?vue&type=script&lang=js"
export * from "./DeleteMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports